<div class="modal-content">
  <ng-container *ngComponentOutlet="content"></ng-container>
</div>
